import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const create = async (data: { pin: string }) => await httpRequest.post("/api/auth/pin", data);

export const change = async (data: { oldPin: string; pin: string }) => await httpRequest.put("/api/auth/pin", data);

export const check = async (data: { pin: string }) => await httpRequest.put("/api/auth/pin/check", data);
